export default "__VITE_ASSET__cc12a963__"